import { createCrudHooks } from '../../../shared/api/crud-hooks';
import { cargosApi } from './api';
import type { CargoDto, CargoInput, CargoListItem } from './types';

export const cargosHooks = createCrudHooks<CargoListItem, CargoDto, CargoInput>({
  queryKey: ['cargos'],
  api: cargosApi,
});
